export default __webpack_public_path__ + "static/media/sa-img.d02cc25f.webp";